import { Component } from 'react';
import DomainImage from '../../components/DomainImage';
import Loading from '../../components/Loading';
import { isTrue } from '../../helpers/isTrue';
import Message from '../Message';
import { editUsers } from '../Onboarding/components/queries';

class EditViewer extends Component {
    constructor(props) {
        super();
        this.domains_for_viewer =
            window.domains_for_viewer?.map((item) => ({ ...item, active: isTrue(item.active) })) ??
            [];
        this.onChangeInput = this.onChangeInput.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.slectAll = this.slectAll.bind(this);
        this.deleteMessage = this.deleteMessage.bind(this);

        this.notActiveDomains = this.domains_for_viewer
            ?.filter((item) => !item.active)
            .map((item) => item.id);

        this.activeDomains = this.domains_for_viewer
            ?.filter((item) => item.active)
            .map((item) => item.id);
        this.state = {
            domains: [...this.activeDomains],
            email: props.email,
            first_name: props.first_name,
            last_name: props.last_name,
            allSelect: false,
            errors: {},
            loading: false,
        };
    }

    onChange(domain) {
        const domains = this.state.domains;
        const newDomains = domains.includes(domain)
            ? domains.filter((item) => item !== domain)
            : [...domains, domain];

        this.setState({
            domains: newDomains,
            errors: {
                ...this.state.errors,
                domains: false,
            },
            allSelect:
                newDomains.length === this.domains_for_viewer.length - this.notActiveDomains.length,
        });
    }

    onChangeInput(e) {
        this.setState({
            [e.target.name]: e.target.value,
            errors: {
                ...this.state.errors,
                [e.target.name]: false,
            },
        });
    }

    slectAll() {
        if (this.state.allSelect) {
            this.setState({
                domains: [],
                allSelect: false,
            });
        } else {
            this.setState({
                domains: this.activeDomains,
                allSelect: true,
            });
        }
    }

    isInvalid(body) {
        const errors = {};
        let response = false;

        for (let key in body) {
            if ((Array.isArray(body[key]) && !body[key].length) || !body[key]) {
                errors[key] = true;
                response = true;
            }
        }
        this.setState({
            errors,
        });

        return response;
    }

    async onSubmit() {
        try {
            const body = {
                first_name: this.state.first_name,
                last_name: this.state.last_name,
                email: this.state.email,
                domains: this.state.domains,
            };
            if (this.isInvalid(body)) return;

            this.setState({
                loading: true,
            });

            const res = await editUsers(body, this.props.id);
            const data = await res.json();
            if (res.status === 200) {
                window.location.href = '/settings';
            } else {
                this.setState({
                    loading: false,
                    message:
                        data.result ??
                        data?.detail ??
                        data?.[0]?.result ??
                        data?.[0]?.email?.result ??
                        'Something went wrong',
                    message_tags: 'error',
                });
            }
        } catch (err) {
            this.setState({
                loading: false,
                message: err.message ?? 'Something went wrong',
                message_tags: 'error',
            });
        }
    }

    deleteMessage() {
        this.setState({ message: '' });
    }

    render() {
        return (
            <>
                <div className="settings-add-user">
                    <div className="d-flex justify-content-between align-items-center">
                        <h2 className="page-title">Add User</h2>
                        <div>
                            <div className="d-flex justify-content-md-end">
                                <a
                                    href="/settings/"
                                    rel="noreferrer"
                                    className="button button-outline button-primary width-sm mx-md-2 text-center"
                                >
                                    Cancel
                                </a>
                                <button
                                    type="submit"
                                    rel="noreferrer"
                                    className="button button-filled button-primary width-sm d-flex justify-content-center align-items-center"
                                    onClick={this.onSubmit}
                                    disabled={this.state.loading}
                                >
                                    {this.state.loading && <Loading onlyPreloader padding={10} />}
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card p-20">
                        <div className="settings-add-user-header">Fill User Personal Details</div>
                        <div className="settings-add-user-body">
                            <div className="text-field mb-3 settings-add-user-body-input">
                                <label htmlFor="first_name" className="form-label">
                                    First Name
                                </label>
                                <input
                                    name="first_name"
                                    placeholder="First Name"
                                    id="first_name"
                                    className="form-control"
                                    value={this.state.first_name}
                                    onChange={this.onChangeInput}
                                />
                                {this.state.errors['first_name'] && (
                                    <div className="error-message">This field is required</div>
                                )}
                            </div>
                            <div className="text-field mb-3 settings-add-user-body-input">
                                <label htmlFor="last_name" className="form-label">
                                    Last Name
                                </label>
                                <input
                                    name="last_name"
                                    placeholder="Last Name"
                                    id="last_name"
                                    className="form-control"
                                    value={this.state.last_name}
                                    onChange={this.onChangeInput}
                                />
                                {this.state.errors['last_name'] && (
                                    <div className="error-message">This field is required</div>
                                )}
                            </div>
                            <div className="text-field mb-3 settings-add-user-body-input">
                                <label htmlFor="email" className="form-label">
                                    Email
                                </label>
                                <input
                                    name="email"
                                    placeholder="Email"
                                    className="form-control"
                                    id="email"
                                    value={this.state.email}
                                    onChange={this.onChangeInput}
                                />
                                {this.state.errors['email'] && (
                                    <div className="error-message">This field is required</div>
                                )}
                            </div>
                        </div>
                        <div className="customers-selects-header">Select Domain(s)</div>
                        {this.state.errors['domains'] && (
                            <div className="error-message">
                                You must selecte at list one element
                            </div>
                        )}
                        <div className="customers-selects">
                            <div className="customers-selects-item">
                                <div className="d-flex align-items-center">
                                    <input
                                        id="domain-all"
                                        type="checkbox"
                                        onChange={this.slectAll}
                                        checked={this.state.allSelect}
                                    />
                                    <label htmlFor="domain-all">
                                        <span>Select All</span>
                                    </label>
                                </div>
                            </div>
                            {this.domains_for_viewer?.map((item) => (
                                <div
                                    key={item.id}
                                    className="customers-selects-item"
                                    style={{
                                        opacity: this.notActiveDomains.includes(item.id) ? 0.3 : 1,
                                    }}
                                >
                                    <div className="d-flex align-items-center">
                                        <input
                                            id={`domain-${item?.id}`}
                                            type="checkbox"
                                            onChange={() => this.onChange(item?.id)}
                                            checked={this.state.domains.includes(item?.id)}
                                            disabled={this.notActiveDomains.includes(item.id)}
                                        />
                                        <label htmlFor={`domain-${item?.id}`}>
                                            <div className="customers-selects-item-img">
                                                <DomainImage domain_name={item.name} />
                                            </div>
                                            <span>{item?.name}</span>{' '}
                                        </label>
                                    </div>
                                    <span className="customers-selects-item-permission">
                                        {item?.active ? 'Active' : 'Not Active'}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                {this.state.message && (
                    <div className="messages">
                        <Message
                            message_tags={this.state.message_tags}
                            message={this.state.message}
                            deleteMessage={this.deleteMessage}
                        />
                    </div>
                )}
            </>
        );
    }
}
export default EditViewer;
